import React from 'react';
import { fmtRelativeTime } from '../utils/formatters';

const SeparatorDot = () => (
    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-[6px]">
        <circle cx="2" cy="2" r="1" fill="currentColor" />
    </svg>
);

export default function FeedHeader({ trackedCount, lastUpdated, compact = false, className = '' }) {
    const relative = lastUpdated ? `cập nhật ${fmtRelativeTime(lastUpdated)}` : 'đang cập nhật';
    
    return (
        <header 
            className={`flex justify-between w-full bg-white transition-all duration-300 ease-in-out ${
                compact 
                    ? 'h-[40px] items-center' 
                    : 'h-[80px] pt-[16px] pb-[12px] items-start'
            } ${className}`}
        >
            {/* Left Content: Title & Description */}
            <div className="flex flex-col min-w-0 gap-0">
                <h1 className={`font-bold text-[#111827] transition-all duration-300 truncate m-0 ${
                    compact ? 'text-[14px] leading-[20px]' : 'text-[20px] leading-[32px]'
                }`}>
                    {compact ? 'Nebula phân tích' : 'Nebula Insights'}
                </h1>
                
                {!compact && (
                    <p className="text-[14px] leading-[20px] text-[#636369] m-0 line-clamp-1 transition-all duration-300">
                        Báo cáo phân tích AI - cập nhật liên tục từ dữ liệu thị trường
                    </p>
                )}
            </div>

            {/* Right Content: Status Badge */}
            <div className={`inline-flex items-center text-[12px] font-medium rounded-[16px] text-[#34D399] border border-[#AEEDD6] transition-all duration-300 shrink-0 ${
                compact 
                    ? 'px-[12px] py-[3px] bg-[#D6F6EB] h-[24px]' 
                    : 'px-[12px] py-[7px] bg-[#34D3990D] h-[32px]'
            }`}>
                <span className="w-[8px] h-[8px] rounded-full bg-[#5DDCAD] shrink-0 mr-[8px]" />
                <div className="flex items-center whitespace-nowrap leading-none">
                    <span>AI đang theo dõi</span>
                    <span className="mx-[6px] opacity-40">·</span>
                    <span>{trackedCount} mã</span>
                    <div className="hidden sm:flex items-center">
                        <span className="mx-[6px] opacity-40">·</span>
                        <span>{relative}</span>
                    </div>
                </div>
            </div>
        </header>
    );
}
